import React, {useEffect, useState} from 'react';

import styled from 'styled-components';
import {v4} from 'uuid';

import {MessageExchange} from 'app/openai/components/TextEdition/MessagePanel';
import {gt} from 'app/utils/i18n';

import {ChatWebsocketProvider} from './ChatWebsocketProvider';
import {ToggleChatButton} from './ToggleChatButton';

interface Props {
  isHidingChat: boolean;
  toggleChat: (url: string) => unknown;
  url: string;
  objectId: number;
  contentType: string;
  chatType: 'rag' | 'ragaccount';
  placeholder: string;
}

export function ChatWidget({
  isHidingChat,
  toggleChat,
  url,
  objectId,
  contentType,
  chatType,
  placeholder,
}: Props) {
  const [threadId, setThreadId] = useState(v4());

  useEffect(() => {
    if (!isHidingChat) {
      setThreadId(v4());
    }
  }, [isHidingChat]);

  return (
    <FloatingChatBoxContainer
      glassBackground={!isHidingChat}
      className="position-fixed d-flex flex-row justify-content-end align-items-end m-auto"
    >
      {!isHidingChat ? (
        <ChatWebsocketProvider>
          <FloatingChatBox className="border-rounded d-flex flex-column align-items-stretch justify-content-start px-1 py-0">
            <MessageExchange
              initialAIMessage={gt('How can I help you today?')}
              threadId={threadId}
              chatType={chatType}
              disabled={false}
              object_id={objectId}
              content_type={contentType}
              toggleMessagePanel={() => toggleChat(url)}
              placeholder={placeholder}
            />
          </FloatingChatBox>
        </ChatWebsocketProvider>
      ) : (
        <ToggleChatButton toggleWidget={() => toggleChat(url)} />
      )}
    </FloatingChatBoxContainer>
  );
}

const FloatingChatBoxContainer = styled.div<{
  glassBackground: boolean;
}>`
  right: 0;
  bottom: 0;
  z-index: 9999999999;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: ${({glassBackground}) =>
    glassBackground ? 'blur(10px)' : 'none'};

  /* Mobile styles */
  @media (max-width: 768px) {
    left: 0;
    right: 0;
    width: 100%;
    justify-content: center;
  }
`;

const FloatingChatBox = styled.div`
  box-shadow: rgba(0, 0, 0, 0.05) 0 0 0 1px, rgb(241, 243, 245) 0 5px 20px 0,
    rgba(0, 0, 0, 0.05) 0 3px 3px 0;
  width: 400px;
  min-height: 100px;
  animation: popup-scaling 0.4s ease forwards;

  @keyframes popup-scaling {
    0% {
      transform: scale(0);
      opacity: 0;
    }
    50% {
      transform: scale(1.2);
      opacity: 0.5;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }

  /* Mobile styles */
  @media (max-width: 768px) {
    min-width: auto;
    width: 100%;
    max-width: 100%;
    border-radius: 5px 5px 0 0;
    max-height: 70vh;
    box-shadow: rgba(0, 0, 0, 0.15) 0 0 10px 0;
  }
`;
